import { z } from 'zod';

export const documentRequestSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Invalid email address'),
  propertyAddress: z.string().min(1, 'Property address is required'),
  documents: z.array(z.string()).min(1, 'Documents are required'),
  subjectToFinance: z.boolean(),
  subjectToInspection: z.boolean(),
  subjectToSpecialConditions: z.boolean(),
  interestedInBuildingAndPestInspection: z.boolean(),
});

export type DocumentRequestFormData = z.infer<typeof documentRequestSchema>;
